module.exports = __webpack_public_path__ + "img/avatar.eaca24e1.svg";